import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const BENEFITS = [
  "Presença na plataforma",
  "Visibilidade qualificada",
  "Conexão com o público certo",
  "Autoridade e reputação",
  "Conteúdo em parceria",
  "Reviews verificados (em breve)",
];

const Fornecedores = () => {
  return (
    <section id="fornecedores" data-testid="fornecedores-section" className="bg-maternnia-eucalipto py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-sm font-semibold tracking-widest text-white/70 uppercase">Fornecedores fundadores</span>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-white mt-4 font-medium leading-[1.1]">
              Faça parte da rede de fornecedores fundadores da Maternnia.
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed font-light max-w-lg">
              Estamos selecionando profissionais, clínicas e serviços que valorizam qualidade, confiança e experiência humanizada.
            </p>
          </motion.div>

          <motion.div
            className="bg-white rounded-3xl p-9 md:p-12 shadow-[0_24px_64px_rgba(43,37,38,0.18)]"
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <h3 className="font-serif text-3xl text-maternnia-charcoal font-medium mb-6">Benefícios para parceiros</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 mb-8">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-3">
                  <span className="h-6 w-6 rounded-full bg-maternnia-eucalipto/10 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-maternnia-eucalipto" />
                  </span>
                  <span className="text-sm text-maternnia-charcoal font-light">{b}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/fornecedores"
              data-testid="fornecedor-cta"
              className="group w-full inline-flex items-center justify-center gap-2 bg-maternnia-pink text-white hover:bg-maternnia-pinkHover rounded-full px-8 py-4 text-base font-medium transition-all duration-300 hover:shadow-lg hover:scale-[1.01] active:scale-[0.99]"
            >
              Quero participar
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Fornecedores;
